
<template>
  <p class="note --required">{{ $t('form.messages.repeater_links') }}</p>
  <div class="repeater" v-for="(action, actionIndex) in actions" :key="`action-${actionIndex}`">
    <div class="aside">
      <span class="round-number">{{ actionIndex + 1 }}</span>

      <button class="delete-button" @click.stop.prevent="removeFormSection(action.id, actionIndex)"
        :disabled="form.submitted || actions.length <= 1">
        <Icon id="trash" />
      </button>
    </div>
    <RapidLinkForm :ref="`formAction${actionIndex}`" :action="action" :index="actionIndex" :id="action.id" :key="action.id"
      @update:valid="handleFormValidity" />
  </div>
</template>

<script>
import RapidLinkForm from '@/components/form/blocks/RapidLinkForm.vue'
import { Icon } from '@/components/global'

export default {
  name: 'EditActions',
  components: { Icon, RapidLinkForm },
  data() {
    return {
      actions: [],
      form: {
        submitted: false,
        valid: false
      },
    }
  },
  methods: {
    add() {
      this.form.valid = false
      this.actions.push({
        id: 0,
        title: '',
        url: '',
        icon: ''
      })
    },
    async removeFormSection(id, index) {
      if (this.actions.length > 1) {
        this.form.submitted = true

        let title = this.actions[index].title

        this.actions.splice(index, 1)

        if (id !== 0) {
          await this.$action.destroy(id)
        }

        this.messageToTooltip('d', title)

        this.handleFormValidity()

        this.form.submitted = false
      }
    },
    messageToTooltip(action, title) {
      if (action === 'd') {
        this.$popup.report(`${title} ${this.$t('popup.deletedElement')}`, false)
      } else {
        this.$popup.report(`${this.$t('popup.theRapidLinks')} ${this.$t('popup.modifiedElement')}`, false)
      }
    },
    async submit() {
      this.handleFormValidity()

      if (this.form.valid) {
        for (let i = 0; i <= this.actions.length - 1; i++) {
          if (this.$refs[`formAction${i}`]) {
            await this.$refs[`formAction${i}`][0].submit()
          }
        }

        this.$router.back()
        this.messageToTooltip('e', '')
      }
    },
    handleFormValidity() {
      this.form.valid = true
      for (let i = 0; i <= this.actions.length - 1; i++) {
        if (this.$refs[`formAction${i}`]) {
          if (!this.$refs[`formAction${i}`][0].form.valid) {
            this.form.valid = false
          }
        }
      }

      this.$emit('update:valid', this.form.valid)
    }
  },
  async beforeMount() {
    await this.$action.init()

    this.actions = Array.from(this.$action.all)
  },
  watch: {
    'actions.length': {
      handler() {
        this.$emit('update:actions', { enabled: this.actions.length < 5 })
      },
      immediate: true
    }
  },
  emits: ['update:actions', 'update:valid'],
}
</script>